import type { AspectRatioInterface } from '@/types/generics'
import {
  calculateTransformationParams,
  generateImageSrc,
  generateImageSrcset,
} from '../media-transformer'

export function hybridImageBinding({
  ratio,
  widths,
}: {
  ratio: keyof AspectRatioInterface
  widths: number[]
}) {
  return {
    ':url'() {
      const { width, height, transformationParams } =
        calculateTransformationParams(this.width, this.height, ratio)

      this.width = width
      this.height = height

      if (this.url) {
        this.src = generateImageSrc(this.url, transformationParams, this.width)
        this.srcset = generateImageSrcset(
          this.url,
          transformationParams,
          widths,
        )
        this.srcsetWebp = this.srcset.replaceAll(/\.(jpe?g|png)/g, '.webp')
      }
    },
  } as any
}
